// VinCentrix is a vehicle-acquisition CRM, not a retail trade-in workflow.
// Remove legacy trade-in surfaces from the rendered CRM while preserving historical data.
const LABEL_RE = /\btrade[ -]?in(?:s)?\b/i;
const SAFE_TEXT_TAGS = new Set(['BUTTON','A','H1','H2','H3','H4','LABEL','SPAN','P']);

const removeTradeInSurface = root => {
  if (!root || root.nodeType !== 1) return;
  const nodes = [root, ...root.querySelectorAll('*')];
  nodes.forEach(el => {
    if (!el.isConnected) return;
    const text = (el.textContent || '').trim();
    if (!text || !LABEL_RE.test(text)) return;
    if (SAFE_TEXT_TAGS.has(el.tagName) && el.children.length === 0) {
      const action = el.closest('button,a,[role="button"]');
      (action || el).remove();
      return;
    }
    const className = String(el.className || '');
    if (/trade.?in/i.test(className)) el.remove();
  });
};

const scan = () => removeTradeInSurface(document.body);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once:true });
else scan();
new MutationObserver(mutations => mutations.forEach(m => m.addedNodes.forEach(n => removeTradeInSurface(n)))).observe(document.documentElement,{childList:true,subtree:true});
export {};
